import React from 'react'
import ReactDOM from 'react-dom/client'

import { Provider } from 'react-redux'
import store from './redux/stores.ts';
import { ThemeProvider } from '@emotion/react'
import { theme } from './components/theme.ts'
import App from './App.tsx';

import "./assets/styles.css";

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
          <App/>
      </ThemeProvider>
    </Provider>
  // </React.StrictMode>,
)